import React from 'react'

import { FormikValues } from 'formik'

import InputField from '@/components/FormikInputs/v3/InputField'
import { Step } from '@/components/Stepper'

interface ContactFormProps {
  values: FormikValues
  selectedCategory: string
}

export const ContactForm = ({ values, selectedCategory }: ContactFormProps): Step => {
  return {
    title: 'Contact information',
    content: () => (
      <div className='flex flex-col w-full gap-3'>
        <InputField
          name='manual_name'
          placeholder={
            selectedCategory === 'applicant' || selectedCategory === 'other'
              ? 'Contact Name*'
              : values.contact_type === 'hoa'
              ? 'HOA Name*'
              : 'Company Name'
          }
          style='default'
          showError={false}
        />
        {values.contact_type === 'hoa' && (
          <>
            <InputField
              name='hoa_subdivision_name'
              placeholder='Neighborhood/Building Name'
              style='default'
              showError={false}
            />
          </>
        )}
        {selectedCategory !== 'other' && (
          <InputField
            name='contact_name'
            placeholder={values.contact_type === 'hoa' ? 'HOA Contact Name*' : 'Contact Name'}
            style='default'
            showError={false}
          />
        )}
        {values.contact_type === 'hoa' && (
          <>
            <InputField
              name='title'
              placeholder='Title*'
              style='default'
              showError={false}
            />
          </>
        )}
        <InputField
          name='phone'
          placeholder={values.contact_type === 'hoa' ? 'Phone*' : 'Phone'}
          parentClassName='w-full'
          style='default'
          showError={false}
        />
        <InputField
          name='email'
          placeholder={values.contact_type === 'hoa' ? 'E-mail*' : 'E-mail'}
          parentClassName='w-full'
          style='default'
          showError={false}
        />
        <InputField
          name='address'
          placeholder='Address'
          parentClassName='w-full'
          style='default'
          showError={false}
        />
      </div>
    ),
    buttonLabel: 'Next',
    disabledStep: !values.contact_type || !values.currentMode,
    hideButton: true,
  }
}
